import { useState } from "react";
import { toast } from "sonner";
import { Phone, Mail, MapPin } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
import { W2 } from "../site/fx";
import { EnquiryFormFields, submitEnquiry } from "../site/EnquiryPanel";
import { useSite } from "../site/SiteContext";
import { useSEO, waLink, PHONE, PHONE_LINK, EMAIL, ADDRESS } from "../seo";

export default function Contact() {
  useSEO("Contact Sepla — Hotelware Manufacturer in Mumbai", "Contact Sepla, stainless steel hotelware manufacturer in Bhayandar East, Mumbai. Call or WhatsApp +91 98335 36564 for a bulk quotation. We supply across India.");
  const { items, clear } = useSite();
  const [form, setForm] = useState({ name: "", company: "", business_type: "", phone: "", email: "", city: "", message: "" });
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (sending) return;
    setSending(true);
    try {
      await submitEnquiry(form, items.map((i) => ({ code: i.code, name: i.name, qty: i.qty })));
      toast.success("Enquiry sent", { description: "We reply with a quotation." });
      clear();
      setForm({ name: "", company: "", business_type: "", phone: "", email: "", city: "", message: "" });
    } catch {
      toast.error("Could not send — please call or WhatsApp us instead.");
    } finally {
      setSending(false);
    }
  };

  return (
    <main className="page" data-testid="contact-page">
      <header className="page-head">
        <p className="kicker">Contact</p>
        <W2 as="h1" parts={[{ t: "Let's build lasting " }, { t: "value,", em: true }, { t: " together." }]} className="page-title" />
        <p className="page-sub">Tell us what you need: quantities, sizes, finishes or your own branding. We reply with a quotation.</p>
      </header>

      <div className="contact-grid">
        <div className="contact-left">
          <a className="contact-big" href={PHONE_LINK} data-testid="contact-call">
            <Phone size={22} /><span>Call us</span><b>{PHONE}</b>
          </a>
          <a className="contact-big wa" href={waLink("Hi Sepla, I'd like a quotation.")} target="_blank" rel="noreferrer" data-testid="contact-whatsapp">
            <FaWhatsapp size={24} /><span>WhatsApp</span><b>{PHONE}</b>
          </a>
          <a className="contact-big" href={`mailto:${EMAIL}`} data-testid="contact-email">
            <Mail size={22} /><span>Email</span><b>{EMAIL}</b>
          </a>
          <div className="contact-addr" data-testid="contact-address">
            <MapPin size={20} />
            <p>{ADDRESS}</p>
          </div>
          <div className="map-wrap" data-testid="contact-map">
            <iframe
              title="Raj Enterprises — Sepla"
              src={`https://maps.google.com/maps?q=${encodeURIComponent(ADDRESS)}&output=embed`}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>

        <form className="contact-form" onSubmit={submit} data-testid="contact-form">
          <p className="kicker">Quote form</p>
          {items.length > 0 && <p className="contact-note">Your enquiry list ({items.length} product{items.length === 1 ? "" : "s"}) is attached to this request.</p>}
          <EnquiryFormFields form={form} setForm={setForm} prefix="contact" />
          <button className="btn btn-accent contact-submit" type="submit" disabled={sending} data-testid="contact-submit">
            {sending ? "Sending…" : "Send enquiry"}
          </button>
        </form>
      </div>
    </main>
  );
}
